import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LabelValueModule } from 'odq-toolbox';
import { AddressDisplayerComponent } from './address-displayer/address-displayer.component';



@NgModule({
  declarations: [AddressDisplayerComponent],
  exports: [AddressDisplayerComponent],
  imports: [
    CommonModule,
    LabelValueModule,
    TranslateModule,
  ]
})
export class AddressDisplayerModule { }
